enum ComponentTypeTransfer {
    AccuracyValidation = 0,
    Lookup = 1,
    Variable = 2,
    IsinSelector = 3,
    LeiSelector = 4,
    ExchangeRatesSelector = 5,
    AnnaDsbUpiEnrichmentSelector = 6,
    AnnaDsbUpiSelector = 7,
    LSESelector = 8,
    Dictionary = 9,
    UserDefinedFunction = 10,
    FirdsFcaInstrumentSelector = 11,
    FirdsEsmaInstrumentSelector = 12,
    FCARegulatedEntitiesSelector = 13,
    Filter = 14,
    DataSource = 15
}

export default ComponentTypeTransfer;
